/**
 * Which path a device reports on (POS2-1354, shared with the Sites page by POS2-1383, so the two
 * pages cannot describe one device differently). No `device` capture means it has not cut over
 * (POS2-1018).
 */
export function DevicePath({
  device,
}: {
  device: { last_source: "device" | "imported" | null; last_device_at: string | null };
}) {
  if (device.last_source === null) return <span className="text-gray-300">No captures</span>;
  if (device.last_device_at === null)
    return <span className="text-amber-600">DataBridge only</span>;
  return <span>{device.last_source === "device" ? "Direct" : "Direct + DataBridge"}</span>;
}
